module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tktShare.tickets.length != 0) ? _c('div', {
    staticClass: "shareTicketPopUp"
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": _vm.resetTicketsForShare
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body_pop_up"
  }, [_c('div', {
    staticClass: "head_section"
  }, [_c('div', {
    staticClass: "inner_wrap"
  }, [_c('p', [_vm._v("Отправить билет")]), _vm._v(" "), _c('span', {
    staticClass: "closePopUp",
    on: {
      "click": _vm.resetTicketsForShare
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/menu_close.svg"),
      "alt": "close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "body_section"
  }, [_c('div', {
    staticClass: "inner_wrap"
  }, [(_vm.step == 0) ? _c('div', {
    staticClass: "ticket_text"
  }, [_c('table', [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._l((_vm.tktShare.tickets), function(tkt) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(tkt.row))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tkt.place))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (tkt.receiver),
        expression: "tkt.receiver"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (tkt.receiver)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(tkt, "receiver", $event.target.value)
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("Отправить")])]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "sharedThx",
    attrs: {
      "id": "sharedThx"
    }
  }, [_c('div', {
    staticClass: "sharedThxPage"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('p', [_vm._v("Билеты отправлены!")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "index.html"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetTicketsForShare.apply(null, arguments)
      }
    }
  }, [_vm._v("на Главную")])])]) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Ряд:")]), _vm._v(" "), _c('th', [_vm._v("Место:")]), _vm._v(" "), _c('th', [_vm._v("Введите E-mail:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bbd3e38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/share-tickets.vue
// module id = 402
// module chunks = 1